module.exports = __webpack_public_path__ + "fonts/Montserrat-MediumItalic.287208c.ttf";